"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _lodash = _interopRequireDefault(require("lodash"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["open", "label"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Accordion = _styledComponents["default"].div.withConfig({
  displayName: "collapseableWrapper__Accordion"
})(["margin:0;section{transition:all 0.125s ease-in-out;overflow:hidden;&.ac_hidden{transition:all 0.125s ease-in-out;height:20px;}&:not(.ac_hidden) > .toggle .pointer{display:block;transform:rotate(90deg);}}"]);
var ToggleMenu = _styledComponents["default"].button.withConfig({
  displayName: "collapseableWrapper__ToggleMenu"
})(["display:flex;height:20px;cursor:pointer;background:none;border:0;"]);
var Pointer = _styledComponents["default"].div.withConfig({
  displayName: "collapseableWrapper__Pointer"
})(["padding:0;margin-right:10px;width:13px;transition:all 0.125s ease-in-out;"]);
var prepareState = function prepareState(_ref) {
  var _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    label = _ref.label,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (_lodash["default"].isPlainObject(open)) {
    return _objectSpread({
      label: label
    }, open);
  } else {
    return {
      open: open,
      label: label
    };
  }
};
var CollapseableWrapper = exports["default"] = /*#__PURE__*/function (_PureComponent) {
  function CollapseableWrapper() {
    var _this;
    (0, _classCallCheck2["default"])(this, CollapseableWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CollapseableWrapper, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", _objectSpread({}, prepareState(_objectSpread({
      label: _this.props.label
    }, _this.props.collapseable))));
    (0, _defineProperty2["default"])(_this, "toggle", function (e) {
      e.preventDefault();
      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(CollapseableWrapper, _PureComponent);
  return (0, _createClass2["default"])(CollapseableWrapper, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        open = _this$state.open,
        label = _this$state.label;
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement(Accordion, null, /*#__PURE__*/_react["default"].createElement("section", {
        className: open ? '' : "ac_hidden"
      }, /*#__PURE__*/_react["default"].createElement(ToggleMenu, {
        className: "toggle",
        onClick: this.toggle
      }, /*#__PURE__*/_react["default"].createElement(Pointer, {
        className: "pointer"
      }, "\u25B6"), /*#__PURE__*/_react["default"].createElement("div", null, label)), children));
    }
  }]);
}(_react.PureComponent);
CollapseableWrapper.defaultProps = {
  label: "Toggle",
  open: true
};
CollapseableWrapper.propTypes = {
  label: _propTypes.string.isRequired,
  open: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.object]).isRequired
};